import React, { PropTypes } from "react";
import { Field, getFormValues, reduxForm } from "redux-form";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import _ from "lodash";
import moment from "moment";

import { SelectInput, DayPicker } from "../../common/form";

const parseCreatedByUserId = (id) => id.trim();
const parseStartDate = (date) => (date.toJSON ? date.toJSON() : date.trim());
const parseEndDate = (date) => {
  if (date.toJSON) {
    return moment(date).endOf("day").format();
  } else if (date.trim) {
    return date.trim();
  } else {
    return date;
  }
};

class AuditFilters extends React.Component {
  componentWillReceiveProps(nextProps) {
    if (nextProps.dirty && !_.isEqual(nextProps.values, this.props.values)) {
      nextProps.onFilterChange(nextProps.values);
    }
  }

  render() {
    return (
      <div className="audit-filter-form">
        <div className="audit-dates">
          <Field
            id="startDate"
            name="startDate"
            component={DayPicker}
            parse={parseStartDate}
            label={<FormattedMessage id="audit.filters.startDate" />}
          />
          <Field
            id="endDate"
            name="endDate"
            component={DayPicker}
            parse={parseEndDate}
            label={<FormattedMessage id="audit.filters.endDate" />}
          />
        </div>
        <Field
          id="createdByUserId"
          name="createdByUserId"
          component={SelectInput}
          parse={parseCreatedByUserId}
          addBlankOption={true}
          blankMessageKey="audit.filters.allUsers"
          options={this.props.userList}
          label={<FormattedMessage id="audit.filters.user" />}
        />
      </div>
    );
  }
}

AuditFilters.propTypes = {
  dirty: PropTypes.bool,
  onFilterChange: PropTypes.func.isRequired,
  userList: PropTypes.array,
  values: PropTypes.object,
};

const valueSelector = getFormValues("auditFilters");

function mapStateToProps(state) {
  return { values: valueSelector(state) };
}

AuditFilters = connect(mapStateToProps)(AuditFilters);

export default reduxForm({
  form: "auditFilters",
})(AuditFilters);



// WEBPACK FOOTER //
// ./src/components/dashboard/audit/AuditFilters.js